/* tslint:disable */
/* eslint-disable */
/**
 * noco-server
 * noco-server
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime'
import {
  UserForDisplay,
  UserForDisplayFromJSON,
  UserForDisplayFromJSONTyped,
  UserForDisplayToJSON
} from './UserForDisplay'

/**
 *
 * @export
 * @interface CompanyMemo
 */
export interface CompanyMemo {
  /**
   *
   * @type {string}
   * @memberof CompanyMemo
   */
  id?: string
  /**
   *
   * @type {string}
   * @memberof CompanyMemo
   */
  companyId?: string
  /**
   *
   * @type {string}
   * @memberof CompanyMemo
   */
  text?: string | null
  /**
   *
   * @type {string}
   * @memberof CompanyMemo
   */
  discardedAt?: string | null
  /**
   *
   * @type {string}
   * @memberof CompanyMemo
   */
  createdAt?: string
  /**
   *
   * @type {string}
   * @memberof CompanyMemo
   */
  updatedAt?: string
  /**
   *
   * @type {UserForDisplay}
   * @memberof CompanyMemo
   */
  createdBy?: UserForDisplay
  /**
   *
   * @type {UserForDisplay}
   * @memberof CompanyMemo
   */
  updatedBy?: UserForDisplay
}

export function CompanyMemoFromJSON(json: any): CompanyMemo {
  return CompanyMemoFromJSONTyped(json, false)
}

export function CompanyMemoFromJSONTyped(json: any, ignoreDiscriminator: boolean): CompanyMemo {
  if (json === undefined || json === null) {
    return json
  }
  return {
    id: !exists(json, 'id') ? undefined : json['id'],
    companyId: !exists(json, 'company_id') ? undefined : json['company_id'],
    text: !exists(json, 'text') ? undefined : json['text'],
    discardedAt: !exists(json, 'discarded_at') ? undefined : json['discarded_at'],
    createdAt: !exists(json, 'created_at') ? undefined : json['created_at'],
    updatedAt: !exists(json, 'updated_at') ? undefined : json['updated_at'],
    createdBy: !exists(json, 'created_by') ? undefined : UserForDisplayFromJSON(json['created_by']),
    updatedBy: !exists(json, 'updated_by') ? undefined : UserForDisplayFromJSON(json['updated_by'])
  }
}

export function CompanyMemoToJSON(value?: CompanyMemo | null): any {
  if (value === undefined) {
    return undefined
  }
  if (value === null) {
    return null
  }
  return {
    id: value.id,
    company_id: value.companyId,
    text: value.text,
    discarded_at: value.discardedAt,
    created_at: value.createdAt,
    updated_at: value.updatedAt,
    created_by: UserForDisplayToJSON(value.createdBy),
    updated_by: UserForDisplayToJSON(value.updatedBy)
  }
}
